<template>
	<div id="common" style="background-color: #f2f2f2;">
		
		<el-container>
			<!-- 头部 -->
			<el-header style="height: 10rem;">
				<div class="header">
					<div class="header-div">文章列表</div>
				</div>
				<div class="search">
					<div class="searchtitle">文章名称</div>
					<div class="searchtitle1">
						<input class="searchinput" v-model="name" type="text" />
						<img class="searchimg" @click="searchClick()" src="../../assets/shudo/images/u1415.png" />
					</div>
				</div>
			</el-header>  
			<div style="height: 1rem;"></div>
			<el-container style="width: 80%;  margin: auto; padding-bottom:6rem">
				<el-main>
					<div class="list">
					<div class="list-div"  v-for="(item,index) in list" :key="index">
						<div class="list-div1">
							<router-link :to="'/articledetails?id='+item.id">
							
							<div class="title">{{item.title}}</div>
							<div class="connet">{{item.brief}}</div>
							<div class="top">
								<div class="div1" >
									<img  :src="item.three.avatar" />
									<div>{{item.three.username}}</div>
								</div>
								<div>
									<img src="../../assets/shudo/images/u2464.png" />
									<div>{{item.create_time}}</div>
								</div>
								<div>
									<img src="../../assets/shudo/images/u2464.png" />
									<div>{{item.like}}</div>
								</div>
								<div>
									<img src="../../assets/shudo/images/u2466.png" />
									<div>{{item.collect}}</div>
								</div>
							</div>
							</router-link>
							
						</div>
					</div>
					</div>	
					
				</el-main>
			</el-container>
		</el-container>
		
	</div>
	
	


</template>

<script>
	export default {
	    data() {
			return {
				type : '/author_question',
				list : [],
				name : ''
			}
	    },
		created() {
			let that = this;
			that.all({});
			
		},
		methods:{
			searchClick(){
				let that = this;
				that.all({name:that.name});
			},
			all($where){
				let that = this;
				that.$http('get','/api/v1/article/list',$where) .then(function (res) {
					that.list = res.data.list;
				});
			}
		},
	}
	
</script>

<style lang="less">
	@import  '../../../common/css/search.less';
	.el-header {
		height: 10rem;
		padding: 0;
	}
	.lefttype {
		color: #3d3e40 !important;
		font-size: 0.86rem !important;
	}
	.header {
		color: #FFFFFF;
		background-color: rgba(9, 7, 35, 1);
		width: 100%;
		height: 10rem;
		.header-div {
			width: 60%;
			margin: auto;
			display: flex;
			padding-top: 2rem;
			font-style: normal;
			font-size: 1.5rem;
			color:#F2F2F2;
			font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
		}
		
	}
	.el-aside {
		margin-left: 1rem;
		height:23.5rem;
		div {
			font-size: 0.6rem;
			width: 100%;
			height: 2rem;
			line-height: 2rem;
			border-bottom: 1px solid #e9e9e9 ;
			color: #7F7F7F;
		}
	}
	.list {
		width: 80%;
		margin: auto;
		.list-div {
			width: 100%;
			background-color: #FFFFFF;
			height: 8.5rem;
			margin-top:1.2rem;
			.list-div1 {
				width: 88%;
				margin: auto;
				.title {
					padding-top: 1rem;
					font-size: 1rem;
					height: 1.8rem;
				}
				.connet {
					font-size: 0.7rem;
					color: #A4A1A6;
					height: 3rem;
					overflow: hidden;
				  text-overflow: ellipsis;
				  display: -webkit-box;
				  -webkit-line-clamp: 3; //行数
				  -webkit-box-orient: vertical;
				}
				.top {
					display: flex;
						color: #A4A1A6;
					div {
						// min-width: 5rem;
						display: flex;
						margin-left: 0.4rem;
						height: 2rem;
						line-height: 3rem;
						font-size: 0.6rem;
						
						
						img {
							position: relative;
							top: 1rem;
							width: 1rem;
							height: 1rem;
						}
						
						
					}
					.div1 {
						font-size: 1.6rem !important;
						margin-left: 0;
						width: 8rem;
						img {
							position: relative;
							top: 0.6rem;
							width: 1.6rem;
							height: 1.6rem;
						}
						div {
							line-height: 2.6rem;
							font-size: 1rem !important;
						}
						
					}
				}
				
			}
		}
	}
</style>
